export const calculateRiskDifference = (
  cer,
  effectSize,
  effectMeasure,
  eventType = "event"
) => {
  return (1 - getRREffectSize(cer, effectSize, effectMeasure, eventType)) * cer;
};

export const getRREffectSize = (cer, effectSize, effectMeasure, eventType) => {
  switch (effectMeasure) {
    case "OR":
      return riskRatioFromOddsRatio(cer, effectSize);
    case "HR":
      return riskRatioFromHazardRatio(cer, effectSize, eventType);
    default:
      // treat any other measure as RR (as in the old GRADEPro)
      return effectSize;
  }
};

export const riskRatioFromOddsRatio = (cer, effectSize) => {
  if (isNaN(cer)) {
    return effectSize;
  }
  return effectSize / (1 - cer * (1 - effectSize));
};

export const riskRatioFromHazardRatio = (cer, effectSize, eventType) => {
  if (isNaN(cer)) {
    return effectSize;
  }
  if (eventType === "non_event") {
    return Math.pow(cer, effectSize - 1);
  } else {
    return (1 - Math.exp(effectSize * Math.log(1 - cer))) / cer;
  }
};
